import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { tokenStore } from "@/lib/apiClient";
import { trySilentSso } from "@/lib/silentSso";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

trySilentSso({ hasToken: () => !!tokenStore.get(), setToken: (t) => tokenStore.set(t) });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register service worker for PWA / offline support (production-style).
// In dev with CRA hot reload, we still register — workbox-like SW only caches GETs and won't interfere.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((err) => console.warn("[SW] registration failed:", err));
  });
}

